module.exports = __webpack_public_path__ + "static/media/logo_makeover_white.e7fb2edb.png";